import { List } from 'immutable'
import {
  Action,
  AsyncState,
  Fun,
  mk_pair,
  none,
  Option,
  Pair,
  unloadedAsyncState,
  Widget,
  loadingAsyncState
} from 'widgets-for-react'

import { get_page, InitPagesStates, PublicSite_CustomPageData, get_options } from './public_site/application.mod'
import { Block } from './wordpress/types_and_parser/standard_blocks.gen'
import { blocks_renderer } from './public_site/blocks/renderer.mod'
import { Breadcrumb } from './wordpress/types_and_parser/extra_types.mod'
import { CustomBlockData } from './public_site/blocks/custom_blocks/types.mod'
import { ExtraImages } from './public_site/utils/extra_images.mod'
import { PageTemplateState } from './cms/state/types.gen'
import { ParsedNode } from './wordpress/types_and_parser/types.ext.gen'
import { CustomPagesState } from './public_site/custom_pages/types.mod'
import { TemplateState } from './cms/page/types.gen'
import { CustomBlock } from './wordpress/types_and_parser/custom_blocks.mod'
import { getCookieStatus, CookieStatus } from './cms/blocks/cookiebar.utils.mod'
import { WordPress } from './wordpress/wordpress_api'

export type HeaderState = {
  menu_header: HeaderMenus
  menu: 'closed' | 'open'
  contactbar: 'closed' | 'open'
  showSearchBar: boolean
  searchValue: string
  hoveredItem?: WordPress.MenuItem
}

export type CookieState = {
  cookiebar: 'closed' | 'open'
  selectedCookie: CookieStatus
}

export type HeaderMenus = {
  // nav_links: AsyncState<List<ParsedMenuItem>>
  breadcrumb: AsyncState<List<{}>>
}

export type FooterState = {
  menu_footer: FooterMenus
}

export type FooterMenus = {
  // nav_links: AsyncState<List<ParsedMenuItem>>
}

export type BrowserState = {
  viewport: 'mobile' | 'tablet' | 'desktop' | 'large'
}

export type OptionsState = AsyncState<WordPress.OptionsResponse>

export type PublicSiteState = {
  header: HeaderState;
  cookiebar: CookieState;
  footer: FooterState;
  browser: BrowserState;
  options: OptionsState;
  wordlist:  AsyncState<WordPress.WordlistResponse>
  latest_updates: AsyncState<Array<WordPress.UpdateResponse>>
  heroColor: string;
} & PageTemplateState<
  CustomBlockData,
  CustomBlock,
  Block,
  ExtraImages,
  PublicSite_CustomPageData,
  any // change this to PublicSiteState when circular reference is supported in TS
> &
  CustomPagesState;


export const defaultPage: ContentType = x => x;

export type ContentType = (
  placeholder: Widget<
    Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
  >
) => Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>

let initPagesStates = InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>())

export const emptyAppState = (page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType>): PublicSiteState =>
  ({
    ...initPagesStates,
    page: {
      ...initPagesStates.page,
      get_page: get_page,
      display: page(mk_pair(List(), none()))
    },
    browser: {
      viewport: 'desktop'
    },
    header: {
      menu: 'closed',
      contactbar: 'closed',
      menu_header: {
        //nav_links: loadingAsyncState(() => {} Api.loadHeader()),
        breadcrumb: unloadedAsyncState()
      },
      showSearchBar: false,
      searchValue: ''
    },
    cookiebar: {
      selectedCookie: getCookieStatus(),
      cookiebar: getCookieStatus() != 'undecided' ? 'closed' : 'open'
    },
    footer: {
      menu_footer: {
        // nav_links: loadingAsyncState(),
      }
    },
    options: get_options('global-settings'),
    wordlist: get_options('word-list'),
    latest_updates: loadingAsyncState<Array<WordPress.UpdateResponse>>(_ =>
      WordPress.api<WordPress.UpdateResponse>()
        .select('update')
        .where({})
        .getMultiple()
        .then(response =>
          response.data
            ? { kind: 'result', status: 200, value: response.data }
            : {
                kind: 'failed',
                status: 404
              }
        )
    )
  } as PublicSiteState)



// WEBPACK FOOTER //
// ./Client/components/public_site.main.mod.tsx